import { render, staticRenderFns } from "./OvertimeCommentAdded.vue?vue&type=template&id=39c82954"
import script from "./OvertimeCommentAdded.vue?vue&type=script&lang=js"
export * from "./OvertimeCommentAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports